import { useEffect, useState } from "react";
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Swal  from "sweetalert2";
import Web3 from "web3";
import Context from './context/context';
import { EthereumProvider } from "@walletconnect/ethereum-provider";
import Reactconnectwallet from './reactwallet/reactconnectwallet';
import { useLocation } from 'react-router-dom';
import PTGCIndex from './pages/PTGC/index';
import PTGC_Staking from './pages/PTGC/staking';
import PTGC_Dao from './pages/PTGC/dao';
import PTGC_Statistics from './pages/PTGC/statistics';
import PTGC_Onboarding from './pages/PTGC/onboarding';
import UFOIndex from './pages/UFO/index';  
import UFO_Pools from './pages/UFO/pools';
import UFO_Reward from './pages/UFO/reward';
import UFO_Statistics from './pages/UFO/statistics';
import UFO_Onboarding from './pages/UFO/onboarding';
import 'bootstrap/dist/css/bootstrap.min.css';
import './stylesheet/style.css';
import './stylesheet/responsive.css';
import { sendGetRequest } from './Helper/helper'; 
import ScrollToHashElement from './components/ScrollToHashElement';

function App() {
    const [pTGCVolume, setPTGCVolume] = useState({volumeDaily: 0, volumeWeekly: 0, volumeMonthly: 0, volumeQuarterly: 0, volumeSemiAnnually: 0, volumeAnnually: 0,});
    const [UFOVolume, setUFOVolume] = useState({volumeDaily: 0, volumeWeekly: 0, volumeMonthly: 0, volumeQuarterly: 0, volumeSemiAnnually: 0, volumeAnnually: 0,});
    const [ptgcPrice, setPtgcPrice] = useState(0.0);
    const [ufoPrice, setUFOPrice] = useState(0);
    const [plsPrice, setPLSPrice] = useState(0);
    const [loggedIn, setLoggedIn] = useState(false);
    const apiPath = "https://dao.goptgc.com/backend/api/";
    const [modalIsOpen, setIsOpen] = useState(false);
    const [providers, setProviders] = useState();
    const [account, setAccount] = useState();
    const [authTokens, setAuthTokens] = useState("");
    const [CID, setCID] = useState("");
    const projectId = '376766ad58cb967480dae7850898ae28';
    let provider;

    useEffect(() => {
        let lastprovider = localStorage.getItem("lastprovider");
        if(lastprovider==="metamask")
        {
            onMetamaskConnect();
        }
        else if(lastprovider==="walletconnect")
        {
            onWalletConnect();
        }
    }, []);

    async function reactconnectwalletModal() {
        setIsOpen(true);
    }

    async function onMetamaskConnect(){
        await setIsOpen(false);
        try {
            await window.ethereum.request({method:'eth_requestAccounts'});
            provider =  window.ethereum;
            await setProviders(provider);  
            localStorage.setItem("lastprovider", 'metamask');
            await window.ethereum.enable();
            provider.on("accountsChanged", (account) => {
                setAccount(account[0]);
            });
            provider.on("chainChanged", (chainId) => {
                if(parseInt(chainId) !='369') {
                    Swal.fire({
                        title: "Error Found",
                        text: 'Make Sure You Are Using The Pulsechain Network',
                        showCancelButton: false,
                        confirmButtonText: "Ok",
                        showCloseButton: true,
                    });
                }
          });
         await init();
        } catch (e) {
            console.log("Could not get a metamask connection", e);
        }
    } 

    async function onWalletConnect() {
        await setIsOpen(false);
        try {
            provider = await EthereumProvider.init({
                projectId,
                showQrModal: true,
                qrModalOptions: {
                    themeMode: "light",
                },
                chains: [369],
                rpcMap: {
                    369: "https://rpc.pulsechain.com",
                },
                metadata: {
                    name: 'The Grays Currency',
                    description: 'The Grays Currency',
                    url: 'https://ptgc-latest-demo.netlify.app',
                    icons: ['https://ptgc-latest-demo.netlify.app/images/logoIcon.svg']
                  }
            });
            await setProviders(provider);
            localStorage.setItem("lastprovider", 'walletconnect');
            await provider.enable();
            provider.on("accountsChanged", (account) => {
                setAccount(account[0]);
            });
            provider.on("chainChanged", (chainId) => {
                if (parseInt(chainId) != '369') {
                    Swal.fire({
                        title: "Error Found",
                        text: 'Make Sure You Are Using The Pulsechain Network',
                        showCancelButton: false,
                        confirmButtonText: "Ok",
                        showCloseButton: true,
                    });
                }
            });
            await init();
        } catch (e) {
            console.log("Could not get a wallet connection", e);
            return;
        }
    }

    async function onConnect() {
        setIsOpen(true);
    }

    async function onDisconnect() {
        setAccount();
        localStorage.setItem("lastprovider", ''); 
        window.location.reload();
    }
    
    async function init() {
        let web3 = new Web3(provider);
        let account = await web3.eth.getAccounts();
        setAccount(account[0]);
        // setAccount('0xccf8ee6fc3a2be88ae2f462f437bb8035e64d956');
        let chainId = await web3.eth.getChainId();
        if (parseInt(chainId) != '369') {
            Swal.fire({
                title: "Error Found",
                text: 'Make Sure You Are Using The Pulsechain Network',
                showCancelButton: false,
                confirmButtonText: "Ok"
            });
        }
        else
        {
            const lg= await sendRequest({"address":account[0]}, "wallet-connect");
            if(lg.status === 1) {
                setLoggedIn(true);
                setAuthTokens(lg.data)
            }
        }
    }

    useEffect(() => {
        const fetchHistoricalVolumeData = async () =>  {
            const pTGCResponse = await sendGetRequest('historical-data', 'GET');
            if (pTGCResponse && pTGCResponse.status === 200) {
                setPTGCVolume({
                    volumeDaily: parseFloat(pTGCResponse.data.day1).toFixed(0),
                    volumeWeekly: parseFloat(pTGCResponse.data.week1).toFixed(0),
                    volumeMonthly: parseFloat(pTGCResponse.data.month1).toFixed(0),
                    volumeQuarterly: parseFloat(pTGCResponse.data.days90).toFixed(0),
                    volumeSemiAnnually: parseFloat(pTGCResponse.data.days180).toFixed(0),
                    volumeAnnually: parseFloat(pTGCResponse.data.yearly).toFixed(0)
                });
                setPtgcPrice(parseFloat(pTGCResponse.data.ptgc_price));
                setCID(pTGCResponse.data.cid);
            }

            const UFOResponse = await sendGetRequest('ufo/historical-data', 'GET');
            if (UFOResponse && UFOResponse.status === 200) {
                setUFOVolume({
                    volumeDaily: parseFloat(UFOResponse.data.day1).toFixed(0),
                    volumeWeekly: parseFloat(UFOResponse.data.week1).toFixed(0),
                    volumeMonthly: parseFloat(UFOResponse.data.month1).toFixed(0),
                    volumeQuarterly: parseFloat(UFOResponse.data.days90).toFixed(0),
                    volumeSemiAnnually: parseFloat(UFOResponse.data.days180).toFixed(0),
                    volumeAnnually: parseFloat(UFOResponse.data.yearly).toFixed(0)
                });
                setUFOPrice(parseFloat(UFOResponse.data.ufo_price));
            }

            const plsResponse = await fetch('https://api.coingecko.com/api/v3/simple/price?ids=pulsechain&vs_currencies=usd');
            const plsData = await plsResponse.json();
            setPLSPrice(plsData.pulsechain.usd)
        };
        fetchHistoricalVolumeData();
    }, []);

    async function sendRequest(data, _req, myauthorization=false)
      {
          var formBody = [];
          for (var property in data) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(data[property]);
            formBody.push(encodedKey + "=" + encodedValue);
          }
          formBody = formBody.join("&");
          const resp = await fetch(apiPath + _req, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
              Authorization:
              ((loggedIn && authTokens!=="" && myauthorization) ? `Bearer ${authTokens}`: ""),
              Cookie: "ci_session=9d575402035edfbb8df618ba3f668b47143df28b",
            },
            body: formBody,
          });
          return resp.json();
      };

  return (
    <>  
     <Context.Provider value={{ account, onConnect, providers, pTGCVolume, UFOVolume, ptgcPrice, ufoPrice, sendRequest, authTokens, plsPrice, onDisconnect, CID}}>
      <Router>
        <ScrollToHashElement />
        <Routes>
          <Route path='/' element={<PTGCIndex />} />  
          <Route path='/ptgc' element={<PTGCIndex />} /> 
          <Route path='/ptgc-staking' element={<PTGC_Staking />} />  
          <Route path='/ptgc-dao' element={<PTGC_Dao />} />   
          <Route path='/ptgc-statistics' element={<PTGC_Statistics />} /> 
          <Route path='/ptgc-onboarding' element={<PTGC_Onboarding />} /> 
          <Route path='/ufo' element={<UFOIndex />} />  
          <Route path='/ufo-pools' element={<UFO_Pools />} />  
          <Route path='/ufo-reward' element={<UFO_Reward />} />  
          <Route path='/ufo-statistics' element={<UFO_Statistics />} />
          <Route path='/ufo-onboarding' element={<UFO_Onboarding />} /> 
        </Routes>
      </Router>
      </Context.Provider>
     <Reactconnectwallet onWalletConnect={onWalletConnect} onMetamaskConnect={onMetamaskConnect} modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}  />
    </>
  );
}

export default App;